// Small shared helpers for the workers feature forms.

/** Trim a form string, returning undefined when it is blank so optional fields are omitted. */
export const trimOrUndefined = (value: string): string | undefined => (value.trim() ? value.trim() : undefined);
